import React, { type FC } from 'react'

import { Capability, type CybusDetailedVolume, Translation } from '../../../../domain'

import { DeleteIcon } from '../../common'
import { DetailsActionButton } from '../../Details'
import { useAppUsecase } from '../../State'

export const HeaderActions: FC<{ resource: CybusDetailedVolume }> = ({ resource: { id } }) => {
    const bulkDeleteVolumesUsecase = useAppUsecase('bulkDeleteVolumesUsecase')

    return (
        <DetailsActionButton
            data-testid="delete-volume-button"
            text={Translation.DELETE}
            capabilities={[Capability.VOLUMES_MANAGE]}
            onClick={() => bulkDeleteVolumesUsecase.selectVolumes([id])}
            startIcon={<DeleteIcon />}
            variant="dangerOutline"
        />
    )
}
